let articleDiv = document.querySelector('div.page-simple__content.page-simple__content--article')

window.addEventListener('DOMContentLoaded', () => {
  if (articleDiv) {
    articleDiv.getElementsByTagName('p').forEach((element, index) => {
      if (element.children.length) {
        element.children.forEach((child, i) => {
          if (parseInt(child.style.fontSize, 10) <= 14) {
            element.style.lineHeight = 1.0
            element.style.marginTop = '2px'
            element.style.marginBottom = '2px'
            element.style.paddingTop = '2px'
            element.style.paddingBottom = '2px'
          }
        })
      }
    })
  }
})
